<div class="form-group">
  <label>Effective Date:</label>

  <div class="form-check" *ngFor="let upcomingBillDate of membership.upcoming_bill_dates">
    <input class="form-check-input" type="radio"
           name="effectiveDate" id="effectiveDate{{ upcomingBillDate }}"
           [(ngModel)]="effectiveDate"
           [value]="upcomingBillDate">
    <label class="form-check-label" for="effectiveDate{{ upcomingBillDate }}">
      {{ dateStringFromISO8601(upcomingBillDate) }}
    </label>
  </div>
</div>

<div class="alert alert-warning" role="alert"
     *ngIf="isOutsideCancellationDateRange(membership, effectiveDate)">
  Your chosen effective date is outside this membership's cancellation date range ({{ dateStringFromISO8601(membership.membership_cancellation_date_range_start) }} to {{ dateStringFromISO8601(membership.membership_cancellation_date_range_end) }}). Customers cannot choose this date themselves. Please double check that this is correct before submitting.
</div>

<div class="form-group" *ngIf="orgConfigService.getOrganizationConfig().require_membership_cancellation_reason">
  <label for="reasonSelect">Cancellation Reason</label>
  <select class="custom-select"
          name="reason" id="reasonSelect"
          [(ngModel)]="reason">
    <option [ngValue]="null" disabled>---</option>
    <option *ngFor="let reasonOption of orgConfigService.getOrganizationConfig().membership_cancellation_reason_options"
            [ngValue]="reasonOption">{{ reasonOption }}</option>
  </select>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
